// @ts-nocheck
import React from 'react';

import { personaCopy } from '../../../config/marketplaceContent';

import css from './FieldPersonaSelection.module.css';

const OPTIONS = [
  { value: 'standard', title: personaCopy.signupStandardTitle, body: personaCopy.signupStandardBody },
  { value: 'merchant', title: personaCopy.signupMerchantTitle, body: personaCopy.signupMerchantBody },
  { value: 'runner', title: personaCopy.signupRunnerTitle, body: personaCopy.signupRunnerBody },
];

const FieldPersonaSelection = ({ input }) => {
  const value = input.value || 'standard';

  return (
    <fieldset className={css.root} data-testid="signup-persona-selection">
      <legend className={css.legend}>{personaCopy.signupPersonaLegend}</legend>
      <div className={css.options}>
        {OPTIONS.map(option => (
          <label
            key={option.value}
            className={value === option.value ? css.optionActive : css.option}
          >
            <input
              type="radio"
              name={input.name}
              value={option.value}
              checked={value === option.value}
              onChange={input.onChange}
              onBlur={input.onBlur}
            />
            <span className={css.optionTitle}>{option.title}</span>
            <span className={css.optionBody}>{option.body}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
};

export default FieldPersonaSelection;
